import { render, staticRenderFns } from "./XContentCardHeader.vue?vue&type=template&id=1078ab78"
import script from "./XContentCardHeader.vue?vue&type=script&lang=js"
export * from "./XContentCardHeader.vue?vue&type=script&lang=js"
import style0 from "./XContentCardHeader.vue?vue&type=style&index=0&id=1078ab78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports